import { URLParam } from "@/helpers/interfaces/URLParam.ts";

export const cleanHomeURL = () => {
  const urlParams = new URLSearchParams(window.location.search);

  // Remove PaymentResult param
  urlParams.delete(URLParam.PaymentResult);

  history.replaceState(null, "", `${window.location.pathname}?${urlParams.toString()}`);
};
